import { organisationConstants } from '../../../_constants/organisation.constants';

const initialState = { remove_bulk_download_loading : true, remove_bulk_download: null, remove_bulk_download_error: false};

export function removeBulkDownloadReducer(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_REMOVE_BULK_DOWNLOAD_API:
        return {
            remove_bulk_download_loading: true,
            remove_bulk_download: null,
            remove_bulk_download_error: false
        };
      case organisationConstants.RECIEVE_REMOVE_BULK_DOWNLOAD_API:
        return {
            remove_bulk_download_loading: false,
            remove_bulk_download: action.bulkDownload,
            remove_bulk_download_error: false
        };
      case organisationConstants.ERROR_REMOVE_BULK_DOWNLOAD_API:
        return { 
            remove_bulk_download_loading: false,
            remove_bulk_download: null,
            remove_bulk_download_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/bulkDownload/removeBulkDownload.js